import { Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, ElementRef, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-nav-tile',
    templateUrl: './nav-tile.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavTileComponent {
    private readonly router = inject(Router);

    public icon = input.required<string>();
    public label = input.required<string>();
    public description = input.required<string>();
    public link = input<string>();
    public externalLink = input<string>();
    public testId = input<string>();

    constructor() {
        const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
        const handler = (event: Event): void => this.navigate(event);
        // Capture phase on this host (an ancestor of `<sh-card>`) always runs
        // before any listener on the card itself.
        host.addEventListener('click', handler, true);
        inject(DestroyRef).onDestroy(() => host.removeEventListener('click', handler, true));
    }

    /**
     * Navigate via the Angular Router. The `<sh-card>` must keep its `href`
     * attribute so SHUI renders it with the linked-card styling, but that same
     * `href` makes the card's built-in click handler perform a hard
     * `window.location.href` navigation — a full page reload that wipes the
     * in-memory NGXS state (and re-shows the startup spinner). We intercept the
     * click in the capture phase and stop it before the card's handler runs, so
     * navigation stays a client-side router transition.
     */
    private navigate(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        const external = this.externalLink();
        if (external) {
            window.open(external, '_blank');
            return;
        }

        const link = this.link();
        if (link) {
            void this.router.navigateByUrl(link);
        }
    }
}
